import styled, { css } from '@xstyled/styled-components';

export interface CapsuleProps {
  highlighted?: boolean;
}

export const Capsule = styled.spanBox<CapsuleProps>`
  width: 26px;
  min-width: 26px;
  height: 26px;
  min-height: 26px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    max-width: 16px;
    max-height: 16px;
  }
  ${p =>
    p.highlighted
      ? css`
          background: ${p => p.theme.colors.accentDark};
          color: var(--color-on-accent);
          /* Locked capsules use greyDark border; accent-edge is often
             transparent, so outline with on-accent for dark/light brands. */
          border: 1px solid
            color-mix(in srgb, var(--color-on-accent) 45%, transparent);
          > svg {
            fill: var(--color-on-accent);
            stroke: var(--color-on-accent);
          }
        `
      : css`
          background: ${p => p.theme.colors.greyMed};
          color: ${p => p.theme.colors.black};
          border: 1px solid ${p => p.theme.colors.greyDark};
          > svg {
            fill: ${p => p.theme.colors.black};
            stroke: ${p => p.theme.colors.black};
          }
        `};
`;
